module.exports = __webpack_public_path__ + "static/media/icon-alert.e2e340e0.svg";